import { createUseStyles } from 'react-jss'
export default createUseStyles({
  avatar: {
    display: ({ showAvatar }) => showAvatar ? 'block' : 'none',
    marginRight: 10,
    marginLeft: 10,
    '& img': {
      height: '32px',
      width: '32px',
      objectFit: 'cover'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  message: {
    alignSelf: ({ isMe }) => isMe ? 'flex-end' : 'flex-start',
    height: 'auto',
    maxWidth: ({ isReferenceMessage }) => !isReferenceMessage && '85%',
    width: ({ isReferenceMessage }) => isReferenceMessage && '100%'
  },
  dateSeparator: {
    color: 'var(--chat__message__date__separator__color)',
    fontFamily: 'BentonSansMedium',
    fontSize: 12,
    marginTop: '8px',
    textTransform: 'uppercase',
    textAlign: 'center'
  },
  messageContainer: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: ({ isMe }) => isMe ? 'row-reverse' : 'row',
    margin: ({ message }) => message.image ? '8px 8px 15px 50px' : '8px'
  },
  messageWrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  responseWrapper: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
})
